








































import { isAppleDevice } from '@/services/device';
import * as config from '@/settings/env';
import Component from 'vue-class-component';
import BaseComponent from '../base-component.vue';

@Component
export default class BaseLogin extends BaseComponent {
  appleDevice = null;
  
  beforeMount() {
      this.appleDevice = isAppleDevice()
  }
  
  public beforeDestroy(){
    /*LOGIN_PAGE*/
    
  }

  androidStoreClick() {
    if (config.production) {
      this.openAndroidStoreApp();
      return;
    }

    this.dialog.show(
      'alert', 
      'App de Produção', 
      'O aplicativo no Google Play é uma versão de produção. Gostaria de continuar?', 
      'Continuar', 
      () => {
        this.openAndroidStoreApp();
      },
      'Fechar',
      () => {

      }  
    )
  }

  openAndroidStoreApp() {
    window.open('https://play.google.com/store/apps/details?id=br.com.parenteral.twa', '_blank')
  }

}

